// extracted by mini-css-extract-plugin
module.exports = {"labels":"styles_labels__P6d_Z"};